import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types'
import { useRouter } from 'next/router'
import Head from 'next/head'
import { APIURL, PAGEURL } from './../../constants'
import services from './../../components/services'
import Link from 'next/link'
import BottomNav from './../../components/common/BottomNav.js'
import Loading from './../../components/common/Loading.js'
import { DefaultLayout } from '../../layouts'
import { BsReply } from '@react-icons/all-files/bs/BsReply'
import Image from 'next/image'


function BlogComponent(props) {
  const blogTitle = props.title;
  const blog = props.blog;
  const [linkIndex, setLinkIndex] = React.useState([]);
  const [closeSidebar, setCloseSidebar] = React.useState(false)
  const [loading, setLoading] = React.useState(true)
  // let title = props.title
  // let title_with_spaces = ''
  // if (title) {
  //   title_with_spaces = title.replace(new RegExp("\\-","g"),' ')
  // }
  useEffect(() => {
    if (blog && document) {
      let index = []
      let elements = document.getElementsByClassName('section')
      for (let i = 0; i < elements.length; i++) {
        let section = elements[i]
        let section_id = 'section-'+i
        section.setAttribute('id', section_id)
        let header = section.getElementsByClassName('section-header')
        if (header.length > 0) {
          index.push(<div className='header'><a onClick={()=>{setCloseSidebar(true)}} href={'#'+section_id}>{header[0].innerText}</a></div>)
        }
        let sub_headers = section.getElementsByClassName('section-sub-header')
        for (let j = 0; j < sub_headers.length; j++) {
          let sub_header = sub_headers[j]
          let sub_section_id = 'sub-section-'+i + '-' + j
          // if (sub_header.length > 0) {
          sub_header.setAttribute('id', sub_section_id)
          index.push(<div className='sub-header'><a onClick={()=>{setCloseSidebar(true)}} href={'#'+sub_section_id}>{sub_header.innerText}</a></div>)
        }
      }
      setLinkIndex(index)
      setLoading(false)
      return
    }
    setLoading(true)
  }, [loading])

  const { content, image, title, created_at, description, topic_slugs, topic_names } = blog
  let psg = []
  for (let i in topic_slugs) {
    psg.push(
      <div key={'psg-'+i} className="product-container">
        <Link href={PAGEURL.PRODUCT_PICKER(topic_slugs[i], '0')}>
            <div className="product-option">
              {topic_names[i]}
            </div>
        </Link>
      </div>
    )
  }

  let navTabs = {}
  if (linkIndex.length > 0) {
    navTabs['jump_to'] = {
      label: 'Jump To',
      logo: (<BsReply key={'jump-to'}/>),
      content: [
        <div key={'jump-to1'} className="overflow-container sidebar-jump-to">
          {linkIndex}
        </div>
      ]
    }
  }
  if (psg) {
    navTabs['psgs'] = {
      label: 'Product Pickers',
      logo: (<div key={'psg'} className='img' />),
      content: [
        <div key={'psg1'} className="psg-container pt-lg">
          Product Pickers
          <div className="products-flex">
            {psg}
          </div>
        </div>
      ]
    }
  }

  return (
    <div className="home home-blog">
      <Head>
        <title>{blogTitle}</title>
        <meta name='description' content={description}/>
      </Head>
      <Loading loading={loading}>
        {Object.keys(navTabs).length > 0 && (
          <BottomNav
            height={"20%"}
            close={closeSidebar}
            setCloseFalse={setCloseSidebar}
            tabs={navTabs}
            default={null}
          >
          </BottomNav>
        )}
        <div className="blog-title-block">
          <div>
            <h1 className="title-left">
              {title}
            </h1>
            <div className="created-at">
              {created_at}
            </div>
          </div>
          <div className="image-right">
            <Image
              src={image}
              alt={title}
              width={768}
              height={384}
              priority={true}
            />
          </div>
        </div>
        <div className="blog-container">
          <div className="blog-post">
            <div className="blog" dangerouslySetInnerHTML={{ __html: content }} ></div>
          </div>
          <div className="blog-post-right">
          <div className="psg-container">
            Product Pickers
            <div className="products-flex">
              {psg}
            </div>
          </div>
            <div className="link-index">
              <div className="jump-to">Jump To</div>
              {linkIndex}
            </div>
          </div>
        </div>
      </Loading>
    </div>
  )
}

export async function getServerSideProps(context) {
  const { title } = context.query;

  try {
    const response = await services.get_v2(APIURL.GET_BLOG_POSTS, {
      params: { title: title.replace(new RegExp("\\-", "g"), ' ') }
    });
    console.log(response)
    if (response.status && response.status === 'failure') {
      return {
         notFound: true,
       }
    } else {
       return {
         props: {
           title: response.title,
           blog: response,
         },
       }
    }
  } catch (error) {
    return {
      notFound: true,
    };
  }
}

// BlogComponent.getLayout = function getLayout(page) {
//   return (
//     <DefaultLayout>
//       {page}
//     </DefaultLayout>
//   )
// }

// BlogComponent.getInitialProps = async (props) => {
//   const { title } = props.query
//   return { title: title }
// }

// export function getServerSideProps (context) {
//     console.log(context.query)
//     // returns { id: episode.itunes.episode, title: episode.title}
//
//
//     //you can make DB queries using the data in context.query
//     return {
//         props: {
//            title: context.query.title,
//            id: context.query.id//pass it to the page props
//         }
//     }
// }

export default BlogComponent
